/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Studio_AspectInputs */

const en_landing_studio_aspect = /** @type {(inputs: Landing_Studio_AspectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aspect ratio`)
};

const zh_landing_studio_aspect = /** @type {(inputs: Landing_Studio_AspectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`画面比例`)
};

/**
* | output |
* | --- |
* | "Aspect ratio" |
*
* @param {Landing_Studio_AspectInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_studio_aspect = /** @type {((inputs?: Landing_Studio_AspectInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Studio_AspectInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_studio_aspect(inputs)
	return zh_landing_studio_aspect(inputs)
});
export { landing_studio_aspect as "landing.studio.aspect" }